// config/workflows.js
export const WORKFLOWS = {
  'Characterization': {
    tasks: [
      // Documentation Pre-Reqs (1-5)
      { id: 1, name: 'CZ Request identified', group: 'Documentation Pre-Reqs', dependencies: [] },
      { id: 2, name: 'CZ Test Plan created/identified', group: 'Documentation Pre-Reqs', dependencies: [1] },
      { id: 3, name: 'CZ Test Plan approved by CZ Lead', group: 'Documentation Pre-Reqs', dependencies: [2] },
      { id: 4, name: 'CZ Test Plan approved by Apps', group: 'Documentation Pre-Reqs', dependencies: [3] },
      { id: 5, name: 'CZ Test Plan uploaded to SharePoint', group: 'Documentation Pre-Reqs', dependencies: [4] },
      
      // DUT Hardware Pre-Reqs (6-10)
      { id: 6, name: 'IC Date Code approved by Planning Mgr', group: 'DUT Hardware Pre-Reqs', dependencies: [] },
      { id: 7, name: 'EVB Standard BOM confirmed with Apps', group: 'DUT Hardware Pre-Reqs', dependencies: [] },
      { id: 8, name: 'EVB Build Request submitted', group: 'DUT Hardware Pre-Reqs', dependencies: [6, 7] },
      { id: 9, name: 'EVBs assembled', group: 'DUT Hardware Pre-Reqs', dependencies: [8] },
      { id: 10, name: 'EVB CZ Pre-check completed by Apps', group: 'DUT Hardware Pre-Reqs', dependencies: [9] },
      
      // Characterization Status (11-20)
      { id: 11, name: 'All Pre-Reqs complete', group: 'Characterization Status', dependencies: [5, 10] },
      { id: 12, name: 'CZ Testing started', group: 'Characterization Status', dependencies: [11] },
      { id: 13, name: 'CZ Level 1 testing complete', group: 'Characterization Status', dependencies: [12] },
      { id: 14, name: 'CZ Level 2 testing complete (if applicable)', group: 'Characterization Status', dependencies: [12] },
      { id: 15, name: 'CZ Level 3 testing complete (if applicable)', group: 'Characterization Status', dependencies: [12] },
      { id: 16, name: 'CZ all testing complete', group: 'Characterization Status', dependencies: [13, 14, 15] },
      { id: 17, name: 'CZ Report created', group: 'Characterization Status', dependencies: [16] },
      { id: 18, name: 'CZ Report approved by CZ Lead', group: 'Characterization Status', dependencies: [17] },
      { id: 19, name: 'CZ Report uploaded to SharePoint', group: 'Characterization Status', dependencies: [18] },
      { id: 20, name: 'CZ Report link routed for approval (incl Lead AE and Planning Mgr)', group: 'Characterization Status', dependencies: [19] }
    ],
    groups: [
      {
        name: 'Documentation Pre-Reqs',
        layout: 'full-width',
        width: '100%'
      },
      {
        name: 'DUT Hardware Pre-Reqs',
        layout: 'full-width',
        width: '100%',
        note: 'can run in parallel with Documentation'
      },
      {
        name: 'Characterization Status',
        layout: 'full-width',
        width: '100%'
      }
    ]
  },

  'Ops - Test Dev': {
    tasks: [
      { id: 1, name: 'Production Test Request identified (triggered by Production Release)', group: 'Local PTB Correlation and Offset Pre-Reqs', dependencies: [] },
      { id: 2, name: 'Pre-Production Risk Assessment completion confirmed, Block Presence/Absence Noted*', group: 'Local PTB Correlation and Offset Pre-Reqs', dependencies: [1] },
      { id: 3, name: 'PTB Layout requested from DE if required', group: 'Local PTB Correlation and Offset Pre-Reqs', dependencies: [1] },
      { id: 4, name: 'Socket requested if required', group: 'Local PTB Correlation and Offset Pre-Reqs', dependencies: [1] },
      { id: 5, name: 'Bare PTB and socket available for AE/DE', group: 'Local PTB Correlation and Offset Pre-Reqs', dependencies: [1] },
      { id: 6, name: 'Parts (ICs) available for AE/DE', group: 'Local PTB Correlation and Offset Pre-Reqs', dependencies: [1] },
      
      { id: 7, name: 'All Pre-Reqs complete', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [1, 2, 3, 4, 5, 6] },
      { id: 8, name: 'PTB tuned and Correlation Units tested by AE/DE', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [7] },
      { id: 9, name: 'PTP draft, correlation results, and PTB offsets received by Ops from AE/DE', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [8] },
      { id: 10, name: 'PTB and Correlation Units received by Ops from AE/DE for shipment', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [8] },
      { id: 11, name: '*Block cleared if applicable', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [10] },
      { id: 12, name: 'Ops TE PTB package final approval and physical package delivered to Sharzine for shipment', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [11] },
      { id: 13, name: 'PTB hardware package mailed to Test House', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [12] },
      { id: 14, name: 'PTB documentation package and hardware package tracking info emailed to Test House', group: 'Local PTB Correlation and Offset and PTP Status ', dependencies: [13] },
      
      { id: 15, name: 'PTB hardware package received at Test House', group: 'Remote Production Test Deployment Status', dependencies: [14] },
      { id: 16, name: 'Initial correlation data collected at Test House', group: 'Remote Production Test Deployment Status', dependencies: [15] },
      { id: 17, name: 'Initial Test House measurements approved locally', group: 'Remote Production Test Deployment Status', dependencies: [16] },
      { id: 18, name: 'PTP revised for Production (if applicable)', group: 'Remote Production Test Deployment Status', dependencies: [17] },
      { id: 19, name: 'Ops TE approves official release of PTP to Production', group: 'Remote Production Test Deployment Status', dependencies: [18] },
      { id: 20, name: 'Production Release PTP uploaded to SharePoint (PM)', group: 'Remote Production Test Deployment Status', dependencies: [19] }
    ],
    groups: [
      { 
        name: 'Local PTB Correlation and Offset Pre-Reqs', 
        layout: 'full-width',
        width: '100%'
      },
      { 
        name: 'Local PTB Correlation and Offset and PTP Status ', 
        layout: 'full-width',
        width: '100%'
      },
      { 
        name: 'Remote Production Test Deployment Status', 
        layout: 'full-width',
        width: '100%'
      }
    ]
  },

  'PCB Orders': {
    tasks: [
      { id: 1, name: 'PCB Request Form submitted', group: 'PCB Order Pre-Reqs', dependencies: [] },
      { id: 2, name: 'PCB Request accepted', group: 'PCB Order Pre-Reqs', dependencies: [] },

      { id: 3, name: 'All Pre-Reqs complete', group: 'PCB Order Status', dependencies: [1, 2] },
      { id: 4, name: 'PCB Design-Layout started', group: 'PCB Order Status', dependencies: [3] },
      { id: 5, name: 'PCB Design Review complete (if needed)', group: 'PCB Order Status', dependencies: [3] },
      { id: 6, name: 'PCB Design-Layout complete', group: 'PCB Order Status', dependencies: [4, 5] },
      { id: 7, name: 'PCB ordered', group: 'PCB Order Status', dependencies: [6] },
      { id: 8, name: 'PCB received', group: 'PCB Order Status', dependencies: [7] }
    ],
    groups: [
      {
        name: 'PCB Order Pre-Reqs',
        layout: 'full-width',
        width: '60%'
      },
      {
        name: 'PCB Order Status',
        layout: 'full-width',
        width: '60%'
      }
    ]
  },

  'Quality - Thermal Analysis': {
    tasks: [
      // Task 1 ("TA Request identified by PM") removed per Israel's 5/20 request — the act of
      // creating the project is the de facto identification, so the explicit checkbox is redundant.
      // Historical TA projects may still have task_number=1 rows in project_task_completions;
      // WorkflowEngine.getProjectStatus filters unknown task IDs so those orphan rows are ignored.
      { id: 2, name: 'TA Request Form received by Quality from PM', group: 'Thermal Analysis Pre-Reqs', dependencies: [] },
      { id: 3, name: 'Bonding Diagram received by Quality from PM', group: 'Thermal Analysis Pre-Reqs', dependencies: [] },
      { id: 4, name: 'Verified-Functional Parts received by Qualty', group: 'Thermal Analysis Pre-Reqs', dependencies: [] },

      { id: 5, name: 'All Pre-Reqs complete', group: 'Thermal Analysis Status', dependencies: [2, 3, 4] },
      { id: 6, name: 'Decap Request submitted', group: 'Thermal Analysis Status', dependencies: [5] },
      { id: 7, name: 'Decapped parts received', group: 'Thermal Analysis Status', dependencies: [6] },
      { id: 8, name: 'Thermal Analysis data collection started', group: 'Thermal Analysis Status', dependencies: [7] },
      { id: 9, name: 'Thermal Analysis data collection complete', group: 'Thermal Analysis Status', dependencies: [8] },
      { id: 10, name: 'TA Report completed', group: 'Thermal Analysis Status', dependencies: [9] },
      { id: 11, name: 'TA Report uploaded to SharePoint', group: 'Thermal Analysis Status', dependencies: [10] },
      { id: 12, name: 'TA Report and results shared with Requestor', group: 'Thermal Analysis Status', dependencies: [11] }
      
    ],
    groups: [
      { 
        name: 'Thermal Analysis Pre-Reqs', 
        layout: 'full-width',
        width: '60%'
      },
      {
        name: 'Thermal Analysis Status',
        layout: 'full-width',
        width: '60%'
      },
    ]
  },

  // Thermal Modeling (Israel Poore, 2026-09-14): same team and queue as Thermal Analysis, its own
  // deliverables as pre-reqs, and TA's status chain minus the two decap steps. Shares TA's field
  // keys (est_meas_time_days, meas_start_date, ta_report_completion_date) so the Thermal Workbench
  // reads both types through one code path. No num_measurements — modeling is a fixed-effort job.
  'Quality - Thermal Modeling': {
    tasks: [
      { id: 1, name: 'TM Request Form received by Quality', group: 'Thermal Modeling Pre-Reqs', dependencies: [] },
      { id: 2, name: 'Evaluation Board Layout received by Quality', group: 'Thermal Modeling Pre-Reqs', dependencies: [] },
      { id: 3, name: 'Evaluation Board Fab Doc received by Quality', group: 'Thermal Modeling Pre-Reqs', dependencies: [] },
      { id: 4, name: 'Data Sheet with Package Outline Drawing received by Quality', group: 'Thermal Modeling Pre-Reqs', dependencies: [] },
      { id: 5, name: 'Die Layout (JPEG) received by Quality', group: 'Thermal Modeling Pre-Reqs', dependencies: [] },

      { id: 6, name: 'All Pre-Reqs complete', group: 'Thermal Modeling Status', dependencies: [1, 2, 3, 4, 5] },
      { id: 7, name: 'Thermal Modeling data collection started', group: 'Thermal Modeling Status', dependencies: [6] },
      { id: 8, name: 'Thermal Modeling data collection complete', group: 'Thermal Modeling Status', dependencies: [7] },
      { id: 9, name: 'TM Report completed', group: 'Thermal Modeling Status', dependencies: [8] },
      { id: 10, name: 'TM Report uploaded to SharePoint', group: 'Thermal Modeling Status', dependencies: [9] },
      { id: 11, name: 'TM Report and results shared with Requestor', group: 'Thermal Modeling Status', dependencies: [10] }
    ],
    groups: [
      {
        name: 'Thermal Modeling Pre-Reqs',
        layout: 'full-width',
        width: '60%'
      },
      {
        name: 'Thermal Modeling Status',
        layout: 'full-width',
        width: '60%'
      }
    ]
  },

  // Data Sheets is the first type whose applicable task set depends on a field value: an Advance
  // classification never reaches the external website, so tasks 10 and 11 are Not Applicable and are
  // excluded from the dependency graph and the "Complete" check (see WorkflowEngine applicability).
  // Task 12's dependencies resolve differently per classification as a result — [9] for Advance
  // (10/11 filtered out), [9, 11] for Preliminary/Release — so one notify task serves both paths.
  'Documentation - Data Sheets': {
    tasks: [
      { id: 1, name: 'DS request received and scope confirmed with Requestor', group: 'Data Sheet Pre-Reqs', dependencies: [] },
      { id: 2, name: 'Source content received from Requestor (tables, plots, supporting data)', group: 'Data Sheet Pre-Reqs', dependencies: [] },
      { id: 3, name: 'Predecessor DS / template identified', group: 'Data Sheet Pre-Reqs', dependencies: [] },

      { id: 4, name: 'All Pre-Reqs complete', group: 'Data Sheet Status', dependencies: [1, 2, 3] },
      { id: 5, name: 'Source data loaded into GDraft database', group: 'Data Sheet Status', dependencies: [4] },
      { id: 6, name: 'Draft DS rendered and accepted by Steward', group: 'Data Sheet Status', dependencies: [5] },
      { id: 7, name: 'Draft DS uploaded to SharePoint', group: 'Data Sheet Status', dependencies: [6] },
      { id: 8, name: 'Draft routed for approval', group: 'Data Sheet Status', dependencies: [7] },
      { id: 9, name: 'All approvals received', group: 'Data Sheet Status', dependencies: [8] },
      { id: 10, name: 'Approved DS sent to Publisher', group: 'Data Sheet Status', dependencies: [9], appliesWhen: { field: 'ds_class', notIn: ['Advance'] } },
      { id: 11, name: 'DS published to external website', group: 'Data Sheet Status', dependencies: [10], appliesWhen: { field: 'ds_class', notIn: ['Advance'] } },
      { id: 12, name: 'Requestor notified', group: 'Data Sheet Status', dependencies: [9, 11] }
    ],
    groups: [
      {
        name: 'Data Sheet Pre-Reqs',
        layout: 'full-width',
        width: '60%'
      },
      {
        name: 'Data Sheet Status',
        layout: 'full-width',
        width: '60%',
        note: 'Advance stops at approval — publisher/website steps show as N/A'
      }
    ]
  }
};

// Request category for the thermal types (Israel, 2026-09-14): "Urgent Engineering Support" marks a
// request that is blocking engineering activity. Mirrored by FIELD_OPTIONS.request_category in
// server.js. First entry is the create-modal default.
export const REQUEST_CATEGORIES = ['Standard', 'Urgent Engineering Support'];

// The types that share the Thermal Workbench and ONE priority order (Israel: TM "will be stacked
// in the same queue" as TA). Mirrored by PRIORITY_POOLS in server.js.
export const THERMAL_QUEUE_TYPES = ['Quality - Thermal Analysis', 'Quality - Thermal Modeling'];

// Per-type UI configuration for the shared WorkflowModal and the type-aware create modal.
// Types absent from this map fall back to the legacy ProjectDetailsModal and the plain create form.
//
// prereqsTaskNumber / immutableCompletions / supportsHolds mirror the project_types columns of the
// same name — kept in sync manually, the same convention as server.js's TA_TASKS mirror.
export const TYPE_UI = {
  'Quality - Thermal Analysis': {
    workflowLabel: 'Thermal Analysis Workflow',
    fieldsLabel: 'TA Custom Fields',
    prereqsTaskNumber: 5,
    immutableCompletions: true,
    immutableMessage: 'TA tasks cannot be unchecked once completed and saved. Place the project on hold to pause progress.',
    supportsHolds: true,
    thirdClock: {
      label: 'Active measurement time',
      startField: 'meas_start_date',
      endField: 'ta_report_completion_date',
      excludeHolds: true,
      notStartedNote: 'not started'
    },
    createFields: ['request_category', 'num_measurements', 'est_meas_time_days'],
    fieldOptions: { request_category: REQUEST_CATEGORIES },
    createDefaults: {}
  },

  'Quality - Thermal Modeling': {
    workflowLabel: 'Thermal Modeling Workflow',
    fieldsLabel: 'TM Custom Fields',
    prereqsTaskNumber: 6,
    immutableCompletions: true,
    immutableMessage: 'TM tasks cannot be unchecked once completed and saved. Place the project on hold to pause progress.',
    supportsHolds: true,
    thirdClock: {
      label: 'Active measurement time',
      startField: 'meas_start_date',
      endField: 'ta_report_completion_date',
      excludeHolds: true,
      notStartedNote: 'not started'
    },
    createFields: ['request_category', 'est_meas_time_days'],
    fieldOptions: { request_category: REQUEST_CATEGORIES },
    // Israel's standard modeling estimate is 3 weeks. Prefilled (editable) on the create modal so
    // the stored value is an explicit choice, not a server-side default.
    createDefaults: { est_meas_time_days: { value: 21 } }
  },

  'Documentation - Data Sheets': {
    workflowLabel: 'Data Sheet Workflow',
    fieldsLabel: 'Data Sheet Fields',
    prereqsTaskNumber: 4,
    immutableCompletions: false,
    supportsHolds: true,
    thirdClock: {
      // Raw elapsed time, holds NOT excluded: for a data sheet the hold interval IS the
      // waiting-on-approvers time we want to measure, unlike TA where holds pause real work.
      // Ends at task 9 (All approvals received) — tasks 10/11 are publication pipeline, not
      // approval, so published_date is deliberately NOT the anchor (changed with migration 003).
      label: 'Time in approval',
      startField: 'routed_date',
      endField: 'approvals_received_date',
      excludeHolds: false,
      notStartedNote: 'not routed yet'
    },
    // ds_class is required at intake because it determines which tasks apply to the project.
    createFields: ['ds_class', 'part_number', 'ds_revision', 'requestor', 'target_publish_date'],
    requiredCreateFields: ['ds_class'],
    fieldOptions: { ds_class: ['Advance', 'Preliminary', 'Release'] },
    createDefaults: { target_publish_date: { daysFromToday: 14 } },
    // Project Name is derived live in the create modal ("GRF5909 - Advance"): headerFields render
    // as a row directly under Project Type (above the divider), and the Name input sits just below
    // the divider, greyed out with an ✏️ unlock for oddball manual edits. Derive-at-create only —
    // later metadata edits never re-derive the stored name.
    deriveName: '{part_number} - {ds_class}',
    headerFields: ['part_number', 'ds_class']
  }
};

// UI config for a type, or null for legacy types that use the plain modal/create form.
export const getTypeUI = (projectType) => TYPE_UI[projectType] || null;

// Compose a project name from a TYPE_UI deriveName template, e.g. '{part_number} - {ds_class}'.
// Returns null when the type has no deriveName (caller: leave the name alone), and '' until every
// referenced field has a value so a half-filled intake never produces fragments like " - Advance".
export const deriveProjectName = (projectType, fieldValues) => {
  const template = getTypeUI(projectType)?.deriveName;
  if (!template) return null;
  const keys = [...template.matchAll(/\{(\w+)\}/g)].map(m => m[1]);
  if (keys.some(k => !String(fieldValues[k] ?? '').trim())) return '';
  return template.replace(/\{(\w+)\}/g, (_, k) => String(fieldValues[k]).trim());
};

// The pre-req tasks for a type: everything ordered before its "All Pre-Reqs complete" gate.
export const getPrereqTasks = (projectType) => {
  const ui = getTypeUI(projectType);
  const workflow = getWorkflow(projectType);
  if (!ui || !workflow) return [];
  return workflow.tasks.filter(t => t.id < ui.prereqsTaskNumber);
};

// Get workflow configuration for a project type
export const getWorkflow = (projectType) => {
  return WORKFLOWS[projectType] || null;
};

// Get all available project types
export const getAvailableProjectTypes = () => {
  return Object.keys(WORKFLOWS);
};

// User-facing display label for a project type. The DB key stays as-is everywhere it matters
// (project_types.name, queries, type checks); this is purely for option labels and headings.
export const getProjectTypeDisplay = (type) => {
  if (type === 'Quality - Thermal Analysis') return 'Thermal Analysis';
  if (type === 'Quality - Thermal Modeling') return 'Thermal Modeling';
  if (type === 'Documentation - Data Sheets') return 'Data Sheets';
  return type;
};

// Get task by ID within a workflow
export const getTask = (projectType, taskId) => {
  const workflow = getWorkflow(projectType);
  return workflow?.tasks.find(task => task.id === taskId) || null;
};